module.exports = __webpack_public_path__ + "img/logo360.95645295.svg";